import axios from 'packs/modules/axios'

const videoContent = {
  handleSubmit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const videoId = form.dataset.id;
    const videoContentId = form.dataset.contentId;
    const params = {
      authenticity_token: form.querySelector('input[name="authenticity_token"]').value,
    };
    videoContent.accept(videoId, videoContentId, params).then(videoContent.setContent);
    videoContent.set_video_accepted();
  },

  async setContent(data) {
    if (!data || !data.id || !data.contentId) return;
    const elm = document.getElementById(`video_${data.id}_content_${data.contentId}`)
    if (!elm) return;
    elm.innerHTML = data.content || '';
    elm.querySelectorAll('form').forEach(form => {
      form.addEventListener('submit', videoContent.handleSubmit);
    });
    elm.querySelectorAll('form button').forEach(button => {
      button.disabled = false;
    });
    elm.querySelectorAll('script').forEach(oldScript => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes)
        .forEach(attr => newScript.setAttribute(attr.name, attr.value));
      newScript.appendChild(document.createTextNode(oldScript.innerHTML));
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
    const is_first_time = videoContent.is_video_accepted();
    document.querySelectorAll('.js_video_content .first_time').forEach(block => {
      block.style.display = is_first_time ? 'none' : '';
    });
    document.querySelectorAll('.js_video_content .after_second_time').forEach(block => {
      block.style.display = is_first_time ? '' : 'none';
    });
  },

  async accept(videoId, videoContentId, params) {
    try {
      const { data } = await axios.post(
        `/api/v1/video/${videoId}/content/${videoContentId}/accept`,
        params,
        {
          headers: {
            accept: 'application/json'
          }
        }
      )
      if (data?.status !== 'not_found') {
        return data;
      }

      return
    } catch (e) {
      if (e.response && e.response.status === 404) {
        return
      }
      throw e
    }
  },

  is_video_accepted() {
    return window.localStorage.getItem('video_accepted') || false;
  },

  set_video_accepted() {
    window.localStorage.setItem('video_accepted', 'true');
  }
}

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js_video_content form').forEach(form => {
    form.addEventListener('submit', videoContent.handleSubmit);
  });
  document.querySelectorAll('.js_video_content form button').forEach(button => {
    button.disabled = false;
  });
  const is_video_accepted = videoContent.is_video_accepted();
  document.querySelectorAll('.js_video_content .first_time').forEach(block => {
    block.style.display = is_video_accepted ? 'none' : '';
  });
  document.querySelectorAll('.js_video_content .after_second_time').forEach(block => {
    block.style.display = is_video_accepted ? '' : 'none';
  });
})
